module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_7-7f986f2638f6858d0e17c9c51cfccb8b.png";